import { css, type SerializedStyles } from '@emotion/react';

export function ellipsis(maxLine = 2): SerializedStyles {
  return css`
    overflow: hidden;
    text-overflow: ellipsis;
    word-wrap: break-word;
    word-break: break-all;
    display: -webkit-box;
    -webkit-line-clamp: ${maxLine};
    -webkit-box-orient: vertical;
    `;
}
